{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome uzantısı yüklü değil.",
      "CTA": "Uzantıyı yükle"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Geçmiş"
    },
    "HISTORY": {
      "OPEN": "Açık",
      "RECENT": "Son",
      "MISSED": "Cevapsız",
      "LOADING": "Çağrılar yükleniyor...",
      "EMPTY": "Burada çağrı yok",
      "ERROR": "Çağrılar yüklenemedi",
      "CALL": "Geri ara",
      "CALL_STATUS": {
        "BUTTON": "Çağrı durumunu ayarla",
        "TITLE": "Çağrı durumu",
        "SEARCH_PLACEHOLDER": "Durum ara...",
        "LOADING": "Durumlar yükleniyor...",
        "NO_OPTIONS": "Hiçbir çağrı durumu yapılandırılmamış",
        "NO_MATCH": "Eşleşen durum yok",
        "OPTIONS_ERROR": "Durumlar yüklenemedi",
        "RETRY": "Tekrar dene",
        "CONFIRM_QUESTION": "“{status}” olarak ayarlanıp görüşme çözüldü olarak işaretlensin mi?",
        "CONFIRM": "Onayla",
        "BACK": "Geri",
        "CANCEL": "İptal Et",
        "SAVING": "Kaydediliyor...",
        "SAVE_ERROR": "Durum kaydedilemedi",
        "RESOLVE_ERROR": "Durum kaydedildi, ancak görüşme çözüldü olarak işaretlenemedi"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefon numarası, ör. +421903000000",
      "BODY_PLACEHOLDER": "Mesajınızı yazın...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "SMS gönder",
      "SENDING": "Gönderiliyor...",
      "SENT": "SMS gönderildi",
      "LOADING": "SMS gelen kutuları yükleniyor...",
      "NO_INBOX": "Bu hesabın SMS gelen kutusu yok, bu nedenle SMS gönderilemiyor.",
      "INVALID_NUMBER": "Numarayı, başındaki + ile birlikte uluslararası biçimde girin.",
      "ERROR": "SMS gönderilemedi. Lütfen tekrar deneyin."
    },
    "ACTIONS": {
      "CONNECT": "Bağlan",
      "GO_TO_TAB": "O sekmeye git",
      "DISCONNECT": "Bağlantıyı kes",
      "ANSWER": "Yanıtla",
      "HANGUP": "Kapat",
      "HOLD": "Beklet",
      "MUTE": "Mikrofonu sustur",
      "SILENCE": "Sesi kapat",
      "TRANSFER": "Aktar",
      "COMPLETE_TRANSFER": "Aktarımı tamamla",
      "RETURN_TO_CALLER": "Arayana dön",
      "CANCEL_TRANSFER": "Aktarımı iptal et",
      "DIALPAD": "Tuş takımını göster",
      "OPEN_CONVERSATION": "Görüşmeyi aç"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Gelen Çağrı",
      "INCOMING_CALL_FROM": "{name} adlı kişiden gelen çağrı ({number})",
      "INCOMING_CALL_FROM_NUMBER": "{number} numarasından gelen çağrı",
      "ANSWER": "Yanıtla",
      "DECLINE": "Reddet"
    },
    "TRANSFER": {
      "TITLE": "Çağrıyı aktar",
      "PLACEHOLDER": "Aktarılacak numarayı girin...",
      "SEARCH_PLACEHOLDER": "Temsilci ara...",
      "TARGET_PLACEHOLDER": "Seçilen aktarma hedefi",
      "CONFIRM": "Aktar",
      "MODE_DIRECT": "Şimdi aktar",
      "MODE_CONSULT": "Önce temsilciyi ara",
      "CANCEL": "İptal Et"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Tüm kuyruklar için mola vermek istediğinizden emin misiniz?",
      "CONFIRM_READY": "Tüm kuyruklar için hazır durumuna dönmek istediğinizden emin misiniz?",
      "CONFIRM_BREAK_QUEUE": "{queue} kuyruğundan çıkış yapmak istediğinizden emin misiniz?",
      "CONFIRM_READY_QUEUE": "{queue} kuyruğuna giriş yapmak istediğinizden emin misiniz?",
      "LOGIN_TO_QUEUE": "Giriş yap",
      "LOGOUT_FROM_QUEUE": "Çıkış yap",
      "LOGIN_TO_ALL_QUEUES": "Tüm kuyruklara giriş yap",
      "LOGOUT_FROM_ALL_QUEUES": "Tüm kuyruklardan çıkış yap",
      "OPTION_LOGOUT": "Çıkış yap",
      "OPTION_BREAK": "Mola",
      "OPTION_LUNCH": "Öğle yemeği",
      "OPTION_AWAY": "Uzakta",
      "OPTION_DO_NOT_DISTURB": "Rahatsız etmeyin",
      "OPTION_BUSINESS_TRIP": "İş seyahati",
      "CONFIRM": "Onayla",
      "CANCEL": "İptal Et"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Telefon sistemine bağlantı yok",
      "MESSAGE": "İnternet bağlantınız kesilmiş görünüyor. Lütfen kontrol edip tekrar deneyin.",
      "CREDENTIALS_TITLE": "Telefon sistemi kimlik bilgilerinizi reddetti",
      "CREDENTIALS_MESSAGE": "Telefon sistemi, profilinizde kayıtlı kullanıcı adını veya parolayı reddetti. Bunları Profil ayarları'nda kontrol edin veya yöneticinize danışın.",
      "CONFIGURATION_TITLE": "Telefon ayarları geçerli değil",
      "CONFIGURATION_MESSAGE": "SIP kullanıcı adı veya sunucu adresi geçerli bir biçimde değil, bu nedenle telefon bağlanamıyor. Bunu Profil ayarları'ndan düzeltin.",
      "NETWORK_SHORT": "Bağlantı başarısız",
      "CREDENTIALS_SHORT": "Kimlik bilgileri reddedildi",
      "CONFIGURATION_SHORT": "Geçersiz telefon ayarları",
      "RETRY": "Tekrar dene",
      "DISMISS": "İptal Et"
    },
    "CONNECTION_QUALITY": "Bağlantı kalitesi",
    "CONNECTION_QUALITY_EXCELLENT": "Mükemmel",
    "CONNECTION_QUALITY_GOOD": "İyi",
    "CONNECTION_QUALITY_FAIR": "Orta",
    "CONNECTION_QUALITY_POOR": "Zayıf",
    "CONNECTION_QUALITY_DISCONNECTED": "Bağlantı kesildi",
    "STATUS": {
      "OFFLINE": "Telefon çevrimdışı",
      "IN_OTHER_TAB": "Telefon başka bir sekmede bağlı",
      "CONNECTING": "Bağlanıyor...",
      "DISCONNECTING": "Bağlantı kesiliyor...",
      "ONLINE": "Telefon çevrimiçi",
      "DIALING": "Aranıyor",
      "TRANSFERRING": "Aktarılıyor...",
      "CONSULTING": "Temsilciyle görüşülüyor",
      "CALLER_ON_HOLD": "Arayan beklemede",
      "BUSY": "Meşgul",
      "DND": "DND",
      "UNAVAILABLE": "Müsait değil",
      "REJECTED": "Çağrı reddedildi",
      "CALL_FAILED": "Çağrı başarısız oldu"
    },
    "QUEUES": {
      "MORE": "Diğer kuyruklar"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "{number} aranıyor… Bu sekmeyi kapatabilirsiniz.",
    "NO_NUMBER": "Numara belirtilmedi. ?number=+420... kullanın"
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Telefon numarasını girin...",
    "ACTIONS": {
      "DIAL": "Numarayı ara",
      "DIAL_FROM": "Aranacak numarayı seçin"
    },
    "DIAL_FROM": {
      "TITLE": "Gelen kutusu numarasından ara"
    },
    "VALIDATION": {
      "REQUIRED": "Telefon numarası gereklidir",
      "INVALID_FORMAT": "Geçersiz telefon numarası biçimi"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Ses Ayarları ve Testi",
    "SELECT_DEVICE": "Cihaz seçin...",
    "SYSTEM_DEFAULT": "Sistem varsayılanı",
    "SAVED": "Kaydedildi",
    "DISCONNECTED_SUFFIX": "bağlı değil",
    "DEVICE_DISCONNECTED": "Seçili cihaz bağlı değil. Cihaz tekrar bağlanana kadar aramalarda sistem varsayılanı kullanılır.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Mikrofonu Test Et",
      "STOP_TEST": "Testi Durdur",
      "LEVEL": "Seviye:",
      "VERDICT": {
        "LISTENING": "Mikrofona bir şeyler söyleyin…",
        "SILENT": "Sesiniz duyulmuyor. Mikrofonun açık ve doğru mikrofonun seçili olduğundan emin olun.",
        "LOW": "Sesiniz çok kısık duyuluyor. Başka bir mikrofon seçin veya sistem ayarlarından giriş ses düzeyini ayarlayın.",
        "GOOD": "İyi ses — net bir şekilde duyuluyorsunuz."
      }
    },
    "SPEAKER": {
      "TITLE": "Hoparlör",
      "TEST": "Hoparlörü Test Et",
      "TESTING": "Test ediliyor...",
      "VOLUME": "Ses Düzeyi:",
      "USING_DEFAULT": "Seçili çıkış kullanılamıyor — sistem varsayılanı üzerinden çalındı."
    },
    "DONE": "Tamam",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Mikrofona erişilirken hata oluştu. Lütfen izinleri kontrol edin.",
      "MICROPHONE_PERMISSION_DENIED": "Mikrofon erişimi engellendi. Telefonu kullanabilmek için tarayıcınızın site ayarlarından izin verin.",
      "MICROPHONE_SILENT": "Mikrofonunuz herhangi bir ses algılamıyor. Ses ayarlarınızı kontrol edin.",
      "EXTENSION_REQUIRED": "Telefon uzantısı bulunamadı. Mikrofonu kullanabilmek için lütfen yükleyin veya etkinleştirin.",
      "SPEAKER_TEST": "Hoparlör çıkışı test edilirken hata oluştu."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Çevrimdışı",
    "ONLINE": "Çevrimiçi",
    "BUSY": "Meşgul"
  },
  "QUEUE_STATUS": {
    "READY": "Hazır",
    "NOT_READY": "Çağrı kabul etmiyor",
    "WRAP_UP": "Görüşme sonrası",
    "BREAK": "Mola",
    "LUNCH": "Öğle yemeği",
    "AWAY": "Uzakta",
    "DO_NOT_DISTURB": "Rahatsız etmeyin",
    "BUSINESS_TRIP": "İş seyahati",
    "OTHER_CALL": "Diğer çağrı",
    "QUEUE_CALL": "Kuyruk çağrısı",
    "OFFLINE": "Çevrimdışı",
    "ONLINE": "Çevrimiçi",
    "NO_ACCESS": "Telefon yok",
    "PARTIALLY_READY": "Kısmen hazır",
    "MIXED": "Karışık",
    "CHAT_ONLINE": "Çevrimiçi (sohbet)",
    "CHAT_BUSY": "Meşgul (sohbet)",
    "CHAT_OFFLINE": "Çevrimdışı (sohbet)"
  }
}
